import { Component, h } from 'preact'
import axios from 'axios'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  id: number
  isSubscribed?: boolean
}

interface State {
  isSubscribed?: boolean
}

class TopicFavorite extends Component<Props, State> {
  isLoading: boolean = false
  constructor (props: Props) {
    super()
    this.toggleSubscription = this.toggleSubscription.bind(this)
    this.state = {
      isSubscribed: props.isSubscribed
    }
  }

  async componentDidMount () {
    if (typeof window === 'undefined' || !window.inSidedData.user.userid) return
    const res = await axios.get<{subscribed: boolean}>(`/subscribers/topic/${this.props.id}`)
    this.setState({ isSubscribed: res.data.subscribed })
  }

  async toggleSubscription (e: Event) {
    e.preventDefault()
    if (this.isLoading) return
    this.isLoading = true

    const newState = !this.state.isSubscribed
    this.setState({ isSubscribed: newState })
    try {
      await axios(`/subscribers/topic/${this.props.id}`, {
        method: newState ? 'post' : 'delete'
      })
    } catch (err) {
      this.setState({ isSubscribed: !newState })
      throw err
    } finally {
      this.isLoading = false
    }
  }

  render (_: Props, { isSubscribed }: State) {
    if (isSubscribed === undefined) return null
    return (
      <a className={`qa-link-subscribe link link--quiet icon--b icon--star post__action-link ${isSubscribed ? 'is-active' : ''}`} onClick={this.toggleSubscription}>
        <span className='post__action-link__text'>
          <Phrase key={isSubscribed ? 'y' : 'n'} p={isSubscribed ? 'subforum.subscription.unsubscribe' : 'Subscribe'} />
        </span>
      </a>
    )
  }
}

export default TopicFavorite
